<template>
  <el-form
    :model="editForm"
    ref="editForm"
    :rules="rules"
    label-width="110px"
    :hide-required-asterisk="false"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-background="rgba(0, 0, 0, 0.5)"
  >
    <el-row>
      <el-col :span="14">
        <el-row>
          <el-col :span="24">
            <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
              <el-tab-pane label="详细描述" name="0">
                <span>
                  <div id="wangEditor_edit"></div>
                </span>
              </el-tab-pane>
              <el-tab-pane label="解决方案" name="1">
                <span>
                  <div id="wangEditor2_edit"></div>
                </span>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col style="line-height: 40px">附件</el-col>
          <el-col :span="24" style="margin-top: 15px">
            <el-row>
              <el-col :span="8">
                <!-- <el-form-item key="12"> -->
                <el-upload
                  action="#"
                  class="upload-demo"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :auto-upload="false"
                  multiple
                  :limit="5"
                >
                  <el-button type="primary" icon="el-icon-upload" plain
                    >选择附件</el-button
                  >
                </el-upload>
                <!-- </el-form-item> -->
              </el-col>
              <el-col :span="16" style="line-height: 40px">
                <div>(单个文件不能超过50M，支持所有扩展名)</div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <!-- <el-form-item label=""> -->
            <el-table
              :data="editForm.file"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="文件名称"
                align="left"
                prop="filename"
                min-width="250px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <el-link @click="openPreview(scope.row)" type="primary">
                    {{ scope.row.filename }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column
                label="上传时间"
                align="left"
                prop="uploadtime"
                min-width="200px"
                :show-overflow-tooltip="true"
              />

              <el-table-column
                label="上传阶段"
                align="left"
                prop
                min-width="200px"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  <div>{{ scope.row.xm }}{{ scope.row.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="left"
                min-width="100px"
                :show-overflow-tooltip="true"
                fixed
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="handleDownloadFile(scope.row)"
                    >下载</el-button
                  >
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
            <!-- </el-form-item> -->
          </el-col>
          <el-col
            style="
              line-height: 40px;
              display: flex;
              margin: 15px 0;
              justify-content: space-between;
            "
          >
            <div>
              <span style="font-weight: 700; font-size: 16px">评论</span>
              共{{ editForm.pinglun.length }}条评论
            </div>
            <el-button type="primary" @click="handleAddComment">评论</el-button>
          </el-col>
          <el-col :span="24">
            <span>
              <div id="wangEditor3_edit"></div>
            </span>
          </el-col>
          <el-col>
            <div
              v-for="item in editForm.pinglun"
              :key="item.id"
              class="zpsm-comment-item"
            >
              <div class="top">
                <div>{{ item.username ? item.username[0] : "" }}</div>
                <div>{{ item.username }}</div>
              </div>
              <div class="middle">
                <!-- <span v-html="item.content"></span> -->
                <div>
                  <span
                    v-for="(picItem, picIndex) in item.commnetSlice"
                    :key="picIndex"
                  >
                    <span v-if="picItem && picItem.picBig">
                      <span>
                        <el-image
                          style="max-width: 200px"
                          :src="picItem.srcBig"
                          :preview-src-list="[picItem.srcBig]"
                        >
                        </el-image>
                      </span>
                    </span>
                    <span v-else v-html="picItem"></span>
                  </span>
                </div>
              </div>
              <div class="bottom">{{ item.create_time }}</div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10">
        <div class="r">
          <div class="r_title">基本信息</div>
          <div class="r_form">
            <el-row>
              <el-col>
                <el-form-item label="当前状态" prop="status">
                  <el-select
                    v-model="editForm.status"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择当前状态"
                    disabled
                  >
                    <el-option
                      v-for="item in statusList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="问题分类" prop="sort">
                  <el-select
                    v-model="editForm.sort"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择问题分类"
                    @change="handleChangeFl"
                  >
                    <el-option
                      v-for="item in sortList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="严重程度" prop="questionLevel">
                  <el-select
                    v-model="editForm.questionLevel"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择严重程度"
                  >
                    <el-option
                      v-for="item in yzcdList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="所属条线" prop="line">
                  <el-select
                    v-model="editForm.line"
                    filterable
                    default-first-option
                    style="width: 100%"
                    placeholder="请选择所属条线"
                    @change="handleChangeTx"
                  >
                    <el-option
                      v-for="item in txList"
                      :key="item.dictValue"
                      :label="item.dictLabel"
                      :value="item.dictValue"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="bmShowFlag">
                <el-form-item label="所属项目" prop="xmbh">
                  <el-select
                    v-model="editForm.xmbh"
                    clearable
                    filterable
                    style="width: 100%"
                    placeholder="请选择所属项目"
                  >
                    <el-option
                      v-for="item in xmList"
                      :key="item.xmbh"
                      :label="item.xmzt + '-' + item.xmjc"
                      :value="item.xmbh"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="产品版本" prop="productVersion">
                  <el-input
                    show-word-limit
                    placeholder="如：V1.6.3"
                    maxlength="20"
                    v-model="editForm.productVersion"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="所属模块" prop="module">
                  <el-input
                    show-word-limit
                    placeholder="如：业绩预约"
                    maxlength="30"
                    v-model="editForm.module"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="影响版本" prop="influenceVersion">
                  <el-input
                    show-word-limit
                    placeholder="如：V1.6.3"
                    maxlength="20"
                    v-model="editForm.influenceVersion"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="指派给"
                  prop="designee"
                  v-if="editForm.status != 5"
                >
                  <treeselect
                    v-model="editForm.designee"
                    placeholder="请选择员工"
                    :options="deptUser"
                    :disable-branch-nodes="true"
                    :show-count="true"
                    value-consists-of="LEAF_PRIORITY"
                    no-results-text="未搜到任何结果"
                    :clear-on-select="true"
                    :normalizer="normalizer"
                    style="width: 100%"
                    size="small"
                    @select="handleChangeYg"
                  />
                </el-form-item>
                <el-form-item label="现指派给" v-else>
                  <el-input placeholder="请输入内容" value="Closed" disabled />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="指派说明" prop="content">
                  <el-input
                    placeholder="请输入内容"
                    v-model="editForm.content"
                    maxlength="200"
                  >
                    <template slot="append">
                      <div @click="zpsmDialog = true" style>更多</div>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="期望完成时间" prop="finishTime">
                  <el-date-picker
                    type="date"
                    placeholder="选择日期"
                    v-model="editForm.finishTime"
                    style="width: 100%"
                    :clearable="false"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="上线时间" prop="sxsj">
                  <div style="position: relative">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="editForm.sxsj"
                      style="width: 100%"
                      :clearable="false"
                    ></el-date-picker>
                  </div>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="计划工时(天)" prop="planTime">
                  <el-input-number
                    :min="0"
                    :max="99999"
                    label="描述文字"
                    v-model="editForm.planTime"
                    style="width: 100%"
                  >
                    <template slot="append"></template>
                  </el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="指派说明"
      :visible.sync="zpsmDialog"
      width="90%"
      v-if="zpsmDialog"
      id="mx-dialog"
      append-to-body
    >
      <div>
        <!-- <el-input
          type="textarea"
          placeholder="请输入指派说明"
          :rows="5"
          maxlength="100"
          show-word-limit
          v-model="zpsmDetail.zpsm"
        ></el-input>-->
      </div>
      <div class="comment">
        <div
          class="zpsm-comment-item"
          v-for="(item, index) of editForm.designeeList"
          :key="index"
        >
          <div class="top">
            <div>{{ item.createby[0] }}</div>
            <div>{{ item.createby }}</div>
            <div>
              <img src="@/img/zhipai.svg" alt />
            </div>
            <div>{{ item.designee }}</div>
          </div>
          <div class="middle">{{ item.content }}</div>
          <div class="bottom">{{ item.create_time }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="zpsmDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="`${mxParams.id}  ${mxParams.title}> 发起评审`"
      :visible.sync="startReviewDialog"
      width="70%"
      top="20px"
      v-if="startReviewDialog"
      append-to-body
    >
      <startReview
        v-if="startReviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeStartReviewDialog"
        @getList="getList"
      ></startReview>
    </el-dialog>
  </el-form>
</template>
<script>
import {
  checkVal,
  cutContent,
  formatMomentDate,
  getPicList,
} from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import startReview from "../question/startReview";

import { getXmxxList } from "@/api/itWeekly";
import {
  getDictData,
  getQuestionDetail,
  saveComment,
  updateQuestion,
  uploadFile,
} from "@/api/question.js";

import { fetchQuestionTx } from "@/api/common.js";
export default {
  components: { Treeselect, startReview },
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      form: {
        rldxActive: 1,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      fileList: [],
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        line: [
          {
            required: true,
            message: "所属条线不能为空",
            trigger: "change",
          },
        ],
        xmbh: [
          {
            required: true,
            message: "所属项目不能为空",
            trigger: "change",
          },
        ],
        sort: [
          { required: true, message: "问题类型不能为空", trigger: "change" },
        ],
        designee: [
          { required: true, message: "指派人不能为空", trigger: "change" },
        ],
        questionLevel: [
          { required: true, message: "严重程度不能为空", trigger: "change" },
        ],
        finishTime: [
          {
            required: true,
            message: "期望完成时间不能为空",
            trigger: "change",
          },
        ],
      },
      editForm: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
        sfxytx: false,
        sxsj: "",
      },

      txList: [],
      xmList: [],
      sortList: [],
      sortList2: [],
      bmList: [],
      statusList: [],
      yzcdList: [],
      data2: {
        type: 2, //说明：类型1 总部-分公司 2分公司-总部
        htlx: "0", //说明：合同类型，多个,隔开，如DS,SW,SD,TS
        range: 0, //说明：数据范围 1-角色数据权限 0-全部
        htzt: "0",
        //htzt: "1,2,3,4,5", //合同状态，多个,隔开，如1,3
      },
      activeEditor: "0",
      zpsmDialog: false,
      parentDialog: false,
      startReviewDialog: false,
      bmShowFlag: false,
      fullscreenLoading: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    fetchQuestionTx().then((res) => {
      if (res.code == 0) {
        this.txList = res.data;
      }
    });
    getXmxxList(
      this.data2.htlx,
      this.data2.range,
      this.data2.htzt,
      "",
      ""
    ).then((res) => {
      if (res.code == 0) {
        this.xmList = res.data;
      }
    });
    getDictData("pmp_quality_sort", 1).then((res) => {
      if (res.code === 0) {
        this.sortList = res.data;
        this.sortList2 = res.data;
      }
    });
    getDictData("pmp_quality_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
    getDictData("pmp_quality_type", 1).then((res) => {
      if (res.code === 0) {
        this.yzcdList = res.data;
      }
    });
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor_edit`);
    let editor2 = new wangEditor(`#wangEditor2_edit`);
    let editor3 = new wangEditor(`#wangEditor3_edit`);

    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    editor3 = this.editorConfig(editor3, 150);

    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
    this.editor3 = editor3;
  },
  methods: {
    handleChangeTx(i) {
      if (i == 1 || i == 2 || i == 4 || i == 16 || i == 14) {
        this.bmShowFlag = true;
      } else {
        this.bmShowFlag = false;
      }
      if (i == 1 || i == 2 || i == 4 || i == 14) {
        this.sortList = this.sortList2.filter((o) => o.dictValue > 20);
        if (this.editForm.sort < 20) {
          this.editForm.sort = null;
        }
      } else {
        this.sortList = this.sortList2.filter((o) => o.dictValue < 20);
        if (this.editForm.sort > 20) {
          this.editForm.sort = null;
        }
      }
      this.editForm.xmbh = null;
      getDesignee({
        line: i,
        xmbh: this.editForm.xmbh ? this.editForm.xmbh : "",
      }).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.editForm.designee = res.data;
          } else {
            this.editForm.designee = null;
          }
        }
      });
    },
    handleChangeFl(i) {
      if (i < 20) {
        if (
          this.editForm.line == "1" ||
          this.editForm.line == "2" ||
          this.editForm.line == "4" ||
          this.editForm.line == "14"
        ) {
          this.editForm.line = null;
        }
      } else {
        if (
          this.editForm.line != "1" &&
          this.editForm.line != "2" &&
          this.editForm.line != "4" &&
          this.editForm.line != "14"
        ) {
          this.editForm.line = null;
        }
      }
    },
    getList() {
      this.$store.dispatch(
        "question/fetchQuestionListAction",
        this.question.questionList.params
      );
      this.getData();
    },
    getData(isComment) {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          if (isComment) {
            this.editForm.pinglun = res.data.pinglun;
          } else {
            this.editForm = res.data;
            this.editor.txt.html(this.editForm.detail);
            this.editor2.txt.html(this.editForm.jjfa);
            if (this.editForm.finishTime) {
              this.editForm.finishTime = moment(this.editForm.finishTime + "");
            }
            if (this.editForm.sxsj) {
              this.editForm.sxsj = moment(this.editForm.sxsj + "");
            }
            const line = this.editForm.line;
            if (
              line == 1 ||
              line == 2 ||
              line == 4 ||
              line == 16 ||
              line == 14
            ) {
              this.bmShowFlag = true;
            } else {
              this.bmShowFlag = false;
            }
          }
          if (this.editForm.pinglun && this.editForm.pinglun.length > 0) {
            for (let i in this.editForm.pinglun) {
              const picList = getPicList(this.editForm.pinglun[i].content);
              this.editForm.pinglun[i].commnetSlice = cutContent(
                picList,
                this.editForm.pinglun[i].content
              );
            }
          }
          console.log(this.editForm.pinglun);
          if (
            res.data.line == "1" ||
            res.data.line == "2" ||
            res.data.line == "4" ||
            res.data.line == "14"
          ) {
            this.sortList = this.sortList2.filter((o) => o.dictValue > 20);
            if (this.editForm.sort < 20) {
              this.editForm.sort = null;
            }
          } else {
            this.sortList = this.sortList2.filter((o) => o.dictValue < 20);
            if (this.editForm.sort > 20) {
              this.editForm.sort = null;
            }
          }
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      //editor.config.uploadImgShowBase64 = true
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];
      // 配置 onchange 回调函数，将数据同步到 vue 中
      // editor.config.onchange = function () {
      //   if (editor.txt.html() == "") {
      //     editor.txt.html("&nbsp");
      //   }
      // };

      editor.create();
      return editor;
    },

    fetchName(key, arr) {
      for (let i of arr) {
        if (key == i.dictValue) {
          return i.dictLabel;
        }
      }
      return null;
    },
    // isCxfqps 是否是重新发起评审
    saveForm(isCxfqps) {
      let finishTime = null;
      let sxsj = null;
      let statusName = this.fetchName(this.editForm.status, this.statusList);
      let sortName = this.fetchName(this.editForm.sort, this.sortList);
      let questionLevelName = this.fetchName(
        this.editForm.questionLevel,
        this.yzcdList
      );
      let lineName = this.fetchName(this.editForm.line, this.txList);
      let xmmc = null;
      for (let i = 0; i < this.xmList.length; i++) {
        if (this.editForm.xmbh == this.xmList[i].xmbh) {
          xmmc = this.xmList[i].xmjc;
        }
      }

      if (this.editForm.finishTime) {
        finishTime = formatMomentDate(new Date(this.editForm.finishTime));
      }
      if (this.editForm.sxsj) {
        sxsj = formatMomentDate(new Date(this.editForm.sxsj));
      }
      const params = {
        ...this.editForm,
        finishTime,
        statusName,
        sortName,
        questionLevelName,
        lineName,
        xmmc,
        sxsj,
      };
      if (this.editor3.txt.html()) {
        saveComment({
          id: this.mxParams.id,
          status: this.editForm.status,
          content: this.editor3.txt.html(),
        });
      }
      updateQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          if (!isCxfqps) {
            this.$emit("giveFather", this.parentDialog);
            this.$message.success(res.msg);
            this.fullscreenLoading = false;
          } else {
            this.startReviewDialog = true;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    handleChange(file, fileList) {
      //验证上传文件的格式
      // const suffixReg = /(xls|xlsx|pdf|doc|docx|ppt|pptx)$/;
      // const point = file.name.lastIndexOf(".");
      // const suffix = file.name.substr(point + 1);
      // const isFile = suffixReg.test(suffix);
      // if (!isFile) {
      //   this.$message.error("请上传正确格式的文件 !");
      //   fileList.pop();
      //   return false;
      // }
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
      //验证上传文件重复
      // let existFile = fileList
      //   .slice(0, fileList.length - 1)
      //   .find((f) => f.name === file.name);
      // if (existFile) {
      //   this.$message.error("当前文件已经存在!");
      //   fileList.pop();
      //   return false;
      // }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    submitUpload(isCxfqps) {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          this.editForm.detail = this.editor.txt.html();
          this.editForm.jjfa = this.editor2.txt.html();
          if (!this.editForm.detail) {
            this.$message.error("请输入详细描述！");
            return;
          }
          // if (this.editForm.sfxytx != 0 && !this.editForm.sxsj) {
          //   this.$message.error("请选择上线时间！");
          //   return;
          // }
          this.$refs.upload.submit();
          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });
          this.fullscreenLoading = true;

          if (fileLen > 0) {
            //上传文件
            form.append("id", this.mxParams.id);
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    if (!isCxfqps) {
                      this.$message.success("上传成功！");
                    }
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(isCxfqps);
              }
            });
          } else if (fileLen == 0) {
            this.saveForm(isCxfqps);
          } else {
            this.$message.error(res.msg);
            return false;
          }
        } else {
          this.$message.error("请输入表单必填字段！");
        }
      });
    },
    handleDeleteFile(row) {
      deleteFile({ fileId: row.fileId, path: row.url }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getData();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      let url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },

    giveFather() {
      this.parentDialog = false;
    },
    openPreview(row) {
      const url = row.url;
      window.open(url);
    },
    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };
      if (!params.content || checkVal(params.content)) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.editor3.txt.html("");
          this.getData(true);
        }
      });
    },
    handleChangeYg(e) {
      this.editForm.designeeName = e.xm;
    },
    cxfqps() {
      this.startReviewDialog = true;
    },
    closeStartReviewDialog() {
      this.startReviewDialog = false;
      this.$emit("giveFather", this.parentDialog);
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>